import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";


export class GroupExpression extends RJExpressionNode
{
  _expression:RJExpressionNode;

  constructor( parser:RJParser, range:SourceRange = null )
  {
    super( parser, RJExpressionNodeType.GROUP, range );
  }

  setExpression( expression:RJExpressionNode )
  {
    this._expression = expression;
    this._expression._setParent( this );
  }

  cloneNode():GroupExpression
  {
    let clone = new GroupExpression( this.parser, this.sourceRange );
    clone.setExpression( this._expression.cloneNode() );
    return clone;
  }


  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    let groupExpressionElement  = new ElementType( "rj-group-expression" ).create();
    
    if ( this._expression )
    {
      groupExpressionElement.appendChild( this._expression.createHTMLElement() );
    }
    
    element.appendChild( groupExpressionElement );

    return element;
  }
}